module.exports = __webpack_public_path__ + "img/strip-14.97ce37c9.jpg";